import * as React from 'react';
import FieldContainer from './FieldContainer';
import SvgIconButton from 'shared/buttons/SvgIconButton';
import ArrowUp from 'static/icons/arrow_up.svg';
import ArrowDown from 'static/icons/arrow_down.svg';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';
import { GenericInputProps } from 'shared/types/commonPropTypes';
import InputWidget from './InputWidget';

const NumberInputWidget = (props: GenericInputProps) => {
  const { value, option, label } = props;

  const parsedValue = option?.suffix ? parseInt(value as string, 10) : value;
  const handleClick = (operation: (val: number) => number) => {
    props.onChange({ val: Number(operation(parsedValue as number).toFixed(2)), index: props.index });
  };

  const handleOnChange = (newValue: { val: unknown }) => {
    props.onChange({
      val: option?.suffix ? newValue.val : parseFloat(newValue.val as string),
      index: props.index
    });
  };

  const valueComponent = (
    <InputWidget
      inputType={'number'}
      onChange={handleOnChange}
      value={(parsedValue ?? '') as number | string}
      placeholder={'Auto'}
      className={`text-ev-dark-purple font-bold w-16 py-0 text-right h-6 min-h-0 mr-1 placeholder-ev-dark-purple
    ${option?.className ?? 'bg-ev-grey'}
  `}
    />
  );

  return (
    <FieldContainer label={label} className={props.className} id={props.option?.id} value={valueComponent}>
      <div className="w-6 h-6 bg-ev-grey rounded flex flex-col items-center justify-evenly drop-shadow-number-input">
        <SvgIconButton
          Icon={ArrowUp}
          buttonColor={ButtonColor.Purple}
          width={8}
          height={4}
          onClick={() => handleClick((val) => ++val)}
          buttonClasses="rounded-t w-5 h-[0.625rem] content-center"
        />
        <SvgIconButton
          Icon={ArrowDown}
          buttonColor={ButtonColor.Purple}
          width={8}
          height={4}
          onClick={() => handleClick((val) => --val)}
          buttonClasses="rounded-b w-5 h-[0.625rem] content-center"
        />
      </div>
    </FieldContainer>
  );
};

export default NumberInputWidget;
